<script setup lang="ts">
import { SpeedInsights } from '@vercel/speed-insights/vue';
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';

import DraftCompetitionWarning from '@/components/DraftCompetitionWarning.vue';
import MainHeader from '@/components/MainHeader.vue';
import { router } from '@/router';
import { useCompetitionStore } from '@/store/useCompetitionStore';

import { appendClipboard } from './helpers/appendClipboard';

const store = useCompetitionStore();

const { currentCompetitionId } = storeToRefs(store);

onMounted(async () => {
  appendClipboard(currentCompetitionId);

  await router.isReady();
  const { id } = router.currentRoute.value.params;
  store.initalise(id);
});
</script>

<template>
  <MainHeader />
  <DraftCompetitionWarning v-if="store.isDraftCompetition" />
  <div class="result-page">
    <router-view />
  </div>
  <SpeedInsights />
</template>

<style lang="scss">
html,
body,
#root {
  height: 100%;
}

body {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  background-color: #e9e9e9;
  font-family: Verdana, Arial, Helvetica, sans-serif;
  margin: 0;

  &.draft {
    background-color: #e2cbcb;
  }
}

.result-page {
  position: relative;
  padding: 2.5rem 0.5rem;
}

@media print {
  body {
    background-color: #fff;
  }

  header,
  form,
  .fa-trash,
  .competition-select > a,
  [data-qa='btn-publish'],
  [data-qa='btn-delete'],
  [data-qa='select-competition']::before {
    display: none !important;
  }

  .scrollable-table {
    max-width: 100%;
    overflow-x: auto;
  }

  .date-picker {
    background: none !important;
    border: 0 !important;

    &::before {
      content: none !important;
    }
  }

  [data-qa='select-competition'] {
    border: 0 !important;
  }

  .result-page {
    padding: 0.5rem;
  }

  table {
    margin-top: 0.45rem !important;
  }

  table th {
    background-color: #000;
    font-weight: bold !important;
    border: 0 !important;
    border-bottom: 2px solid #000 !important;
  }

  table td,
  table td {
    padding: 0.5rem 1rem !important;
  }

  table tr.odd td {
    background-color: #ddd;
  }
}
</style>
